var _g, _g2, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _rect2, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g3, _path39, _rect3, _rect4, _rect5, _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoldersDemo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "cache-id": "1545ae1e249d45d38ad8dc0d59f48843",
    id: "eY1HTg86k941",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 335 367",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.677757 0 0 0.677757 70.20222 46.436549)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eY1HTg86k943",
    transform: "translate(2.3817 1.086691)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 104,
    rx: 12,
    ry: 12,
    transform: "translate(35 249)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1313,282.188v-9.345c-1.2307-.494-2.1315-1.616-2.1315-2.922c0-1.289.8754-2.399,2.1069-2.903-.0008.017.0238.034.0238.051v1.958c0,.799.5874,1.295,1.3865,1.295h.0427c.7991,0,1.3603-.496,1.3603-1.295v-1.958c0-.023.041-.046.0402-.069c1.2552.496,2.1462,1.616,2.1462,2.92c0,1.239-.7917,2.312-1.9403,2.841v9.468c.9025.539,1.5383,1.535,1.5383,2.672c0,1.709-1.4021,3.099-3.1111,3.099-.0188,0,.0131-.001-.0689-.002-1.6409-.03-3.0209-1.408-3.0209-3.098.0025-1.166.6433-2.184,1.6278-2.712Zm1.3947,4.434c.0821,0,.0526.001.0722.001.9493,0,1.7295-.773,1.7295-1.722s-.7687-1.722-1.718-1.722c-.0188,0-.0361-.024-.0541-.023-.9222.031-1.6786.803-1.6786,1.733-.0009.93.7466,1.702,1.649,1.733Z",
    transform: "translate(4.426365 0)",
    fill: "#81919c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1314,282.188v-9.344c-1.2307-.494-2.1315-1.616-2.1315-2.923c0-1.289.8754-2.399,2.1069-2.902-.0008.017.0238.033.0238.05v1.958c0,.799.5874,1.296,1.3865,1.296h.0427c.0254,0,.05-.002.0746-.004v12.861c-.009,0-.0172-.001-.0262-.001-.0189,0-.0361-.024-.0542-.023-.9221.031-1.6786.803-1.6786,1.732c0,.931.7474,1.703,1.6499,1.733.0821.001.0525.002.0722.002.0123,0,.0246-.002.0378-.002v1.379c-.014,0-.0271,0-.0411,0-.0188,0,.0132,0-.0689-.001-1.6409-.031-3.0208-1.408-3.0208-3.098.0016-1.166.6424-2.184,1.6269-2.713Z",
    transform: "translate(4.426365 0)",
    fill: "#5c6a75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4106,271.131h-.0119c-.3308,0-.5989-.268-.5989-.599v-2.933c0-.331.2681-.599.5989-.599h.0119c.3308,0,.5988.268.5988.599v2.933c0,.331-.268.599-.5988.599Z",
    transform: "translate(4.426365 0)",
    fill: "#c3c6cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0094,268.847v-1.248c0-.331-.268-.599-.5988-.599h-.0119c-.3308,0-.5989.268-.5989.599v1.248h1.2096Z",
    transform: "translate(4.426365 0)",
    fill: "#e5e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.185,270.6c-1.38-.429-3.724-.966-4.678-.045h-3.078v-2.978h3.079c0,0,2.506.103,4.965,2.54.215.213.001.573-.288.483Z",
    transform: "translate(4.426365 0)",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.509,268.958c1,.14,2.297.525,3.048,1.32-.009-.057-.035-.113-.084-.161-2.459-2.436-4.965-2.54-4.965-2.54h-3.079v1.274c0,0,3.403-.127,5.08.107Z",
    transform: "translate(4.426365 0)",
    fill: "#c3c6cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0098,267.577v2.978c.5709-.565,1.4442-.877,2.4192,0v-2.978c-.975.877-1.8483.565-2.4192,0Z",
    transform: "translate(4.426365 0)",
    fill: "#81919c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.09,271.682h-2.268v13.065h2.268v-13.065Z",
    transform: "translate(4.426365 0)",
    fill: "#f0a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.09,271.682h-1.155v13.065h1.155v-13.065Z",
    transform: "translate(4.426365 0)",
    fill: "#e96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.822,284.05v2.827c0,.62.503,1.123,1.123,1.123h.023c.62,0,1.123-.503,1.123-1.123v-2.827h-2.269Z",
    transform: "translate(4.426365 0)",
    fill: "#c3c6cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.935,284.05v3.949c.003,0,.006,0,.01,0h.023c.62,0,1.123-.503,1.123-1.123v-2.827h-1.156v.001Z",
    transform: "translate(4.426365 0)",
    fill: "#81919c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.243,271.298c0,.41-.333.743-.743.743h-3.088c-.411,0-.743-.333-.743-.743c0-.411.332-.743.743-.743h3.088c.41,0,.743.332.743.743Z",
    transform: "translate(4.426365 0)",
    fill: "#c3c6cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3968,272.908c-.006.299-.0225.6-.0419.899.0187-.299.0359-.6.0419-.899h.5251c.0979-1.418.1877-2.835.1623-4.228h-.7555-2.3741l.1414,1.287c.1967-.043.3276-.082.3276-.082v.003c.0808-.023.1645-.039.2535-.039.4668,0,.8535.34.9268.787.0082.05.0135.101.0135.153c0,.519-.4212.94-.9403.94-.0882,0-.172-.016-.2535-.039v.003c0,0-.0524-.013-.1421-.031l.1361,1.245h1.9792v.001Z",
    transform: "translate(4.426365 0)",
    fill: "#5e6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0837,268.68c.0247,1.393-.0643,2.81-.1623,4.228h1.7151l.1347-1.226c-.0322.008-.0502.012-.0502.012v-.003c-.0807.023-.1653.039-.2535.039-.5191,0-.9402-.421-.9402-.94c0-.053.0052-.103.0134-.154.0733-.445.46-.786.9268-.786.0882,0,.172.015.2535.038v-.003c0,0,.0935.029.2402.063l.1391-1.268h-.2125-1.8041v0Z",
    transform: "translate(4.426365 0)",
    fill: "#727a82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9025,267.185c-.1855-.465-.4802-.834-.837-1.151-1.4549.197-2.5709,1.305-2.5709,2.645h.4593h2.3741c.5834-.283.828-.987.5745-1.494Z",
    transform: "translate(4.426365 0)",
    fill: "#8b9cb0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0659,266.034c.3568.317.6515.686.837,1.151.2536.507.0097,1.212-.5744,1.494h.7554h1.8034.2125.4592c0-.892-.4959-1.68-1.2551-2.167-.4997-.321-1.1123-.512-1.7772-.512-.1571.001-.3104.014-.4608.034Z",
    transform: "translate(4.426365 0)",
    fill: "#c3d7eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7204,269.888c-.0808-.023-.1653-.039-.2536-.039-.4667,0-.8535.34-.9268.787.2566.971,2.4362.688,2.9987.359.6418-.375.5244-.432.849.136.3239.568,1.012.729,1.5827.343.1234-.199.196-.433.196-.684c0-.721-.5842-1.306-1.3052-1.306-.217,0-.4189.059-.5992.152v-.007c0,0-.8272.434-1.3957.434-.3411,0-.6844-.064-.9051-.116-.1473-.034-.2401-.062-.2401-.062v.003h-.0007Z",
    transform: "translate(4.426365 0)",
    fill: "#ccdceb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3875,271.131c-.3246-.569-.2072-.512-.849-.136-.5625.329-2.7421.611-2.9987-.36-.0082.05-.0134.101-.0134.153c0,.519.4211.94.9402.94.0882,0,.172-.016.2536-.039v.003c0,0,.0179-.004.0501-.012.1481-.033.6096-.127,1.095-.127.5902,0,1.4092.4,1.4092.4v-.006c.1766.09.374.145.5857.145.469,0,.8796-.248,1.1093-.62-.5692.387-1.2574.226-1.582-.341Z",
    transform: "translate(4.426365 0)",
    fill: "#8099a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7548,271.13c.3239-.568.2072-.511.849-.136.5624.329,2.7421.612,2.9986-.359-.0733-.446-.46-.787-.9267-.787-.0883,0-.1721.015-.2536.039v-.003c0,0-.1309.04-.3276.082-.2184.047-.5184.096-.8176.096-.5684,0-1.3964-.433-1.3964-.433v.006c-.1803-.094-.3823-.152-.5992-.152-.721,0-1.3052.585-1.3052,1.306c0,.251.0725.485.1959.684.5708.386,1.2589.225,1.5828-.343Z",
    transform: "translate(4.426365 0)",
    fill: "#ccdceb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4224,271.689c.0808.023.1646.039.2536.039.5198,0,.9402-.421.9402-.94c0-.052-.0052-.103-.0134-.153-.2566.971-2.4362.689-2.9987.36-.6418-.376-.5244-.433-.849.136-.3239.567-1.012.728-1.5827.342.2296.372.6402.62,1.1092.62.2117,0,.4092-.055.5857-.144v.006c0,0,.8198-.401,1.4092-.401.4092,0,.8011.067,1.0031.109.089.017.1421.031.1421.031v-.005h.0007Z",
    transform: "translate(4.426365 0)",
    fill: "#8099a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8543,290.635c.5714-.241.9926-.846.9926-1.4.1062-.905.0381-1.811-.0905-2.716-.0158-.113-.033-.227-.0509-.339-.0352-.227-.0733-.453-.113-.68-.0396-.226-.08-.452-.1196-.679-.0434-.248-.086-.496-.1249-.745h-.2858c-.5722.732-2.0046,2.754-2.0046,4.687c0,.855.4795,1.597,1.1841,1.974.0538.004.1069.005.1593.002.0524-.002.1047-.008.1556-.017.1025-.018.2019-.048.2977-.087Zm-.8198-1.783c-.1578-.866.2162-1.676.3845-1.984.0643-.118.2124-.16.3298-.097.1182.064.1616.213.0973.33-.1437.263-.463.95-.3329,1.664.0643.353.2947.555.4256.644.1115.075.1406.226.0651.337-.0471.069-.1234.107-.202.107-.0471,0-.0942-.014-.1361-.042-.3359-.226-.5595-.567-.6313-.959Z",
    transform: "translate(4.426365 0)",
    fill: "#72dff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4726,284.82c.0397.227.0801.453.1197.68.0396.226.0778.452.113.679.0179.113.0344.226.0508.339.1287.905.1967,1.811.0905,2.716c0,.555-.4203,1.16-.9926,1.4-.095.039-.1944.069-.2969.087-.0509.009-.1032.015-.1556.017-.0523.003-.1055.002-.1593-.002.3141.168.6724.264,1.0532.264.1039,0,.2049-.009.3051-.023c1.0913-.149,1.9321-1.082,1.9321-2.214c0-.601-.1421-1.215-.3531-1.795-.463-1.273-1.2618-2.389-1.653-2.892h-.1788c.0397.249.0815.496.1249.744Z",
    transform: "translate(4.426365 0)",
    fill: "#67c7d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.802,289.854c.0778,0,.1549-.038.202-.107.0755-.112.0456-.263-.0651-.338-.1309-.088-.3613-.29-.4256-.644-.1301-.713.1892-1.401.3329-1.663.0643-.118.0209-.266-.0973-.33-.1174-.064-.2655-.021-.3298.097-.1683.308-.5423,1.118-.3845,1.984.0711.392.2954.733.632.96.0419.027.0891.041.1354.041Z",
    transform: "translate(4.426365 0)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9211,272.908h-.5251c-.006.299-.0224.6-.0419.899-.006.101-.0127.2-.0194.299-.0763,1.197-.1354,2.376.4039,3.455.4967.994,1.303,1.18,2.2305,1.184.5296.002,1.0988-.056,1.6717-.056.7159,0,1.4384.089,2.0967.494c1.015.676,1.4009,1.824,1.3785,3.059h1.6747c.0128-.579.0068-1.692-.5378-2.707-.5729-1.068-1.4488-1.959-3.5798-3.047-2.0562-1.05-2.3173-1.613-2.3173-2.471c0-.631,0-1.108,0-1.108h-.7211-1.7136v-.001Z",
    transform: "translate(4.426365 0)",
    fill: "#c3d7eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1177,282.241c.0224-1.235-.3643-2.382-1.3785-3.059-.659-.405-1.3808-.494-2.0966-.494-.573,0-1.1422.058-1.6718.056-.9268-.004-1.7338-.19-2.2305-1.184-.54-1.079-.481-2.258-.4039-3.454.006-.1.0127-.2.0194-.3.0187-.299.0359-.6.0419-.899h-1.9792-.8586c0,0,0,.366,0,1.306c0,.219-.0352.413-.095.586-.1242.36-.3606.627-.6388.825-.7929,1.459-.3538,3.36.8168,4.53c1.0449,1.176,2.5117,1.089,3.9755,1.01.6418-.17,1.0996-.361,1.7271-.585.2304-.083.484-.169.7779-.261c1.3808-.431,2.1154.694,2.1154,1.538c0,.143,0,.274,0,.394.0284-.006.0576-.009.0875-.009h1.7914v0Z",
    transform: "translate(4.426365 0)",
    fill: "#8b9cb0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6416,280.155c-1.1706-1.171-1.6097-3.072-.8168-4.531-.4122.292-.9148.432-1.2828.5v.555v3.155.414c.6029.056,1.6194.218,2.3524.587c1.1123.561,2.3831.655,3.5058.385.0756-.018.1466-.037.2169-.056-1.4638.079-2.9298.166-3.9755-1.009Z",
    transform: "translate(4.426365 0)",
    fill: "#8392a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6531,279.835v1.205c0,.084-.0172.163-.0471.235h1.3067c.3471,0,.6283-.282.6283-.629v-.398-.414h-1.8879v.001Z",
    transform: "translate(4.426365 0)",
    fill: "#6f7b8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6528,276.679h1.8886v-.555-.256c0-.347-.2812-.629-.6283-.629h-1.2925c.0209.062.0329.127.0329.195v1.245h-.0007Z",
    transform: "translate(4.426365 0)",
    fill: "#cedded"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.542,276.679h-1.8887v3.155h1.8887v-3.155Z",
    transform: "translate(4.426365 0)",
    fill: "#9fb4c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4532,280.641c1.1617-1.626,1.241-3.753.7757-5.781-.0568-.018-.1167-.031-.1795-.031h-.4436c-.3336,0-.6043.271-.6043.604v.674v4.3.232c.1585.121.3119.143.4517.002Z",
    transform: "translate(4.426365 0)",
    fill: "#d4e3f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6531,279.835v-3.155-1.245c0-.068-.0113-.134-.033-.194-.062-.181-.2086-.322-.3919-.38.466,2.03.3867,4.155-.7757,5.782-.1398.139-.2932.118-.4525-.003v.401c0,.334.2708.605.6044.605h.4435c.2506,0,.4653-.153.5573-.37.0307-.072.0471-.151.0471-.234v-1.207h.0008Z",
    transform: "translate(4.426365 0)",
    fill: "#becfe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3238,282.241c-.0299,0-.0591.003-.0875.009-.193.04-.3388.212-.3388.417v.982c0,.011.0022.02.003.03c2.0046.264,4.0817.376,4.2186-1.406-.0501-.021-.1055-.033-.1631-.033h-.1638-1.6747-1.7937v.001Z",
    transform: "translate(4.426365 0)",
    fill: "#d4e3f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9014,283.679c.0157.221.1974.397.4226.397h1.7383.2857.1788h1.4302c.2348,0,.4256-.191.4256-.426v-.983c0-.177-.1085-.329-.2626-.393-.1369,1.781-2.214,1.67-4.2186,1.405Z",
    transform: "translate(4.426365 0)",
    fill: "#bdcde0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5 0 0 1.5-106.961357-75.171388)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k9440",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(140.813892 268.832088)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\nl \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k9442",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(135.964438 268.720251)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\na \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k9444",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(132.733838 268.720251)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\nt \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k9446",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(127.455113 268.83596)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\nn \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k9448",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(122.168571 268.732088)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\ne \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k9450",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(116.553914 268.758771)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\nR \n"))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "eY1HTg86k9452",
    transform: "matrix(0 0 0 0 87.999999 301)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 104,
    rx: 12,
    ry: 12,
    transform: "translate(35 249)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5526,293.313v-15.574c-2.0511-.823-3.5525-2.694-3.5525-4.871c0-2.148,1.459-3.998,3.5114-4.838-.0013.029.0397.056.0397.085v3.263c0,1.332.9791,2.159,2.3109,2.159h.0711c1.3319,0,2.2672-.827,2.2672-2.159v-3.263c0-.038.0683-.077.067-.115c2.0921.826,3.5771,2.694,3.5771,4.867c0,2.065-1.3196,3.853-3.2339,4.735v15.779c1.5041.899,2.5639,2.559,2.5639,4.454c0,2.849-2.3369,5.165-5.1852,5.165-.0315,0,.0219-.001-.1149-.003-2.7348-.05-5.0348-2.346-5.0348-5.163.0042-1.943,1.0721-3.64,2.713-4.521Zm2.3245,7.39c.1368.001.0876.002.1204.002c1.5821,0,2.8825-1.288,2.8825-2.87s-1.2813-2.87-2.8634-2.87c-.0314,0-.0601-.04-.0902-.038-1.537.052-2.7977,1.338-2.7977,2.888-.0014,1.55,1.2443,2.837,2.7484,2.888Z",
    fill: "#81919c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5526,293.313v-15.574c-2.0511-.823-3.5525-2.694-3.5525-4.871c0-2.148,1.4591-3.998,3.5115-4.838-.0014.029.0397.056.0397.085v3.263c0,1.332.979,2.159,2.3109,2.159h.0711c.0424,0,.0834-.003.1244-.005v21.434c-.015,0-.0287-.002-.0437-.002-.0315,0-.0602-.04-.0903-.039-1.5369.052-2.7977,1.339-2.7977,2.888c0,1.551,1.2457,2.838,2.7498,2.888.1368.002.0876.003.1204.003.0205,0,.041-.003.0629-.003v2.298c-.0233,0-.0451.001-.0684.001-.0314,0,.0219-.001-.1149-.003-2.7348-.05-5.0347-2.346-5.0347-5.163.0027-1.943,1.0707-3.64,2.7115-4.521Z",
    fill: "#5c6a75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0179,274.885h-.0198c-.5513,0-.9981-.446-.9981-.998v-4.889c0-.551.4468-.998.9981-.998h.0198c.5514,0,.9982.447.9982.998v4.889c0,.552-.4468.998-.9982.998Z",
    fill: "#c3c6cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0161,271.078v-2.08c0-.551-.4468-.998-.9982-.998h-.0198c-.5513,0-.9981.447-.9981.998v2.08h2.0161Z",
    fill: "#e5e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.975,273.999c-2.301-.714-6.2069-1.608-7.7974-.074h-5.1293v-4.963h5.1307c0,0,4.178.171,8.276,4.233.358.355.002.954-.48.804Z",
    fill: "#b1babf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5142,271.264c1.6668.233,3.8288.875,5.0798,2.2-.014-.095-.058-.188-.139-.269-4.098-4.061-8.276-4.233-8.276-4.233h-5.1307v2.124c0,0,5.6722-.213,8.4659.178Z",
    fill: "#c3c6cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0161,268.962v4.963c.9515-.942,2.4063-1.462,4.0322,0v-4.963c-1.6259,1.462-3.0807.942-4.0322,0Z",
    fill: "#81919c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4831,275.803h-3.7805v21.776h3.7805v-21.776Z",
    fill: "#f0a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4832,275.803h-1.9256v21.776h1.9256v-21.776Z",
    fill: "#e96666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7026,296.416v4.712c0,1.034.8384,1.872,1.8719,1.872h.0382c1.0335,0,1.8718-.838,1.8718-1.872v-4.712h-3.7819Z",
    fill: "#c3c6cb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5576,296.415v6.582c.0057,0,.0113.001.017.001h.0382c1.0334,0,1.8718-.838,1.8718-1.872v-4.712h-1.927v.001Z",
    fill: "#81919c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4047,275.162c0,.685-.5542,1.239-1.2385,1.239h-5.1462c-.6843,0-1.2385-.554-1.2385-1.239c0-.684.5542-1.238,1.2385-1.238h5.1462c.6843,0,1.2385.554,1.2385,1.238Z",
    fill: "#c3c6cb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5 0 0 1.5-106.961357-75.171388)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k9468",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(141.091536 268.732088)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\np \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k9470",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(135.694766 268.720251)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\ne \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k9472",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(130.544417 268.720251)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\ne \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k9474",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(125.978984 268.83596)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\nk \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k9476",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(120.382984 268.732088)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\np \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k9478",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(113.730166 268.758771)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\nU\n"))))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 104,
    rx: 12,
    ry: 12,
    transform: "translate(152 133)",
    fill: "#f8f8f8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.56,205.565c-.077-.25-.183-.473-.319-.67-.132-.2-.292-.371-.48-.512-.185-.142-.397-.248-.637-.319-.24-.074-.502-.111-.785-.111-.508,0-.96.128-1.357.384-.397.255-.709.631-.937,1.126-.225.492-.337,1.093-.337,1.8c0,.715.112,1.319.337,1.815.225.495.537.872.937,1.131.4.255.865.383,1.394.383.48,0,.896-.092,1.247-.277.354-.185.626-.446.817-.785.191-.341.286-.742.286-1.2l.388.06h-2.567v-1.339h3.836v1.136c0,.809-.172,1.509-.517,2.1-.344.591-.818,1.047-1.422,1.367-.603.317-1.295.475-2.077.475-.871,0-1.636-.195-2.294-.586-.656-.394-1.168-.953-1.538-1.676-.366-.726-.549-1.588-.549-2.585c0-.763.108-1.445.323-2.045.219-.6.523-1.11.914-1.528.391-.422.85-.742,1.376-.96.526-.222,1.099-.333,1.717-.333.523,0,1.011.077,1.464.231.452.151.854.366,1.205.646.353.28.644.613.872.997.228.385.377.81.448,1.275h-1.745Zm5.446,6.578c-.449,0-.854-.08-1.214-.24-.357-.163-.64-.403-.849-.72-.207-.317-.31-.708-.31-1.173c0-.4.074-.731.222-.992.148-.262.349-.471.605-.628.255-.157.543-.276.863-.356.323-.083.657-.143,1.002-.18.415-.043.752-.081,1.011-.115.258-.037.446-.092.563-.166.12-.077.18-.196.18-.356v-.027c0-.348-.103-.617-.309-.808-.207-.191-.504-.286-.891-.286-.41,0-.734.089-.974.267-.237.179-.397.39-.481.633l-1.56-.222c.123-.431.326-.791.609-1.08.284-.292.63-.511,1.039-.656.409-.147.862-.221,1.357-.221.342,0,.682.04,1.021.12.338.08.647.212.928.397.28.181.504.429.674.743.172.314.258.706.258,1.177v4.746h-1.606v-.974h-.056c-.101.197-.245.382-.429.554-.182.169-.411.306-.688.411-.274.101-.596.152-.965.152Zm.434-1.228c.335,0,.626-.066.873-.198.246-.136.435-.314.567-.536.136-.221.203-.463.203-.725v-.835c-.052.043-.141.083-.267.12-.123.037-.262.069-.416.097-.154.027-.306.052-.457.074-.151.021-.281.04-.392.055-.249.034-.473.089-.67.166s-.352.185-.466.323c-.114.136-.171.311-.171.527c0,.307.113.54.337.697.225.157.511.235.859.235Zm10.595-4.132l-1.524.167c-.043-.154-.118-.299-.226-.434-.104-.136-.246-.245-.425-.328-.178-.083-.397-.125-.655-.125-.348,0-.64.076-.877.226-.234.151-.349.347-.346.587-.003.206.072.374.226.503.157.129.415.235.775.318l1.21.259c.671.145,1.169.374,1.496.688.329.314.495.725.498,1.232-.003.447-.134.841-.392,1.182-.256.339-.611.603-1.067.794-.455.191-.978.286-1.569.286-.868,0-1.567-.181-2.096-.544-.529-.366-.845-.876-.946-1.528l1.629-.157c.074.32.231.561.471.725.24.163.552.244.937.244.397,0,.716-.081.956-.244.243-.164.364-.365.364-.605c0-.203-.078-.371-.235-.503-.154-.133-.394-.234-.72-.305l-1.21-.254c-.68-.142-1.183-.38-1.509-.716-.326-.338-.488-.766-.485-1.283-.003-.437.115-.816.355-1.136.244-.323.581-.572,1.012-.747.433-.179.934-.268,1.5-.268.831,0,1.485.177,1.962.531.48.354.777.832.891,1.435Z",
    transform: "translate(-.586501 0)",
    fill: "#141414"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.166,185.027c-1.074-.009-2.063-.5-2.713-1.348-.651-.848-.866-1.925-.589-2.954l2.103-7.826c.134-.498.204-1.012.209-1.527l.067-7.664l1.018.009-.068,7.665c-.005.6-.086,1.198-.242,1.777l-2.104,7.826c-.195.725-.044,1.484.415,2.082s1.156.944,1.913.951c1.341.012,2.441-1.061,2.453-2.39l.114-12.956c.018-2.042,1.708-3.688,3.766-3.67l4.145.037-.009,1.01-4.145-.037c-1.497-.013-2.726,1.184-2.739,2.669l-.115,12.956c-.016,1.886-1.577,3.407-3.479,3.39Z",
    fill: "#58595b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188.249,165.593l-.933-.008c-.171-.002-.31-.142-.309-.312l.013-1.458c.002-.169.143-.307.314-.305l.933.008c.171.001.31.141.308.311l-.013,1.458c-.001.17-.143.307-.313.306Z",
    fill: "#414042"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M189.063,159.395l-.815-.42l1.228-2.341c.25-.477.622-.88,1.078-1.17l1.349-.858.435.735-1.045.672c-.451.289-.819.69-1.067,1.162l-1.163,2.22Z",
    fill: "#808285"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190.563,155.457c-.456.29-.828.693-1.078,1.171l-1.129,2.152.492.254l1.165-2.219c.248-.473.615-.873,1.066-1.163l1.046-.671-.222-.375-1.34.851Z",
    fill: "#a7a9ac"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.888,160.512l-.048-.025c-.331-.171-.461-.579-.289-.908l.916-1.746c.172-.329.584-.457.915-.286l.048.025c.332.171.461.579.289.908l-.916,1.746c-.172.328-.584.457-.915.286Z",
    fill: "#e96666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.112,163.748l-.189-1.301c-.09-.711.046-1.417.392-2.043l.302-.546.297.162-.302.546c-.311.564-.433,1.199-.352,1.837l.188,1.298-.336.047Z",
    fill: "#be1e2d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M188.955,158.915l-.709.328c-.331-.171-1.057.77-.885.441l1.29-2.459c.171-.328.584-.457.915-.286l.267.097c.331.17.519.637.347.965l-.583,1.254c-.173.328-.312-.169-.642-.34Z",
    fill: "#e96666"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M190.514,158.794l-.044,4.983c-.002.163-.136.293-.299.292l-2.856-.025c-.163-.002-.295-.135-.294-.297l.044-4.866c.002-.241.2-.435.443-.433l2.688.024c.177.002.319.146.318.322Zm-1.451,1.053l.114.001c-.546-.005-.767.46-.772,1.037l-.023,2.512l1.638.014.022-2.512c.006-.576-.433-1.048-.979-1.052Z",
    fill: "#be1e2d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188.139,158.85l2.374.021.001-.077c.002-.176-.141-.32-.319-.322l-2.687-.024c-.243-.002-.442.191-.444.433l-.043,4.866c-.001.162.13.295.294.297l.338.003.042-4.765c.003-.241.202-.434.444-.432Z",
    fill: "#e96666"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M212.456,186.66l-16.629-.147.274-31.031c.012-1.395,1.163-2.516,2.569-2.503l11.535.102c1.406.012,2.537,1.153,2.524,2.548l-.274,31.031",
    fill: "#be1e2d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M210.205,153.081l-11.535-.102c-1.406-.013-2.557,1.108-2.569,2.503l-.274,31.031l1.366.012l13.608-31.751l1.008-1.111c-.435-.359-.994-.577-1.604-.582Z",
    fill: "#f97a7a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196.848,186.168l.271-30.677c.007-.837.699-1.511,1.543-1.504l11.535.102c.842.008,1.523.694,1.515,1.531l-.271,30.677-14.593-.129Z",
    fill: "#e96666"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M213.856,188.114l-19.455-.172.005-.556c.006-.684.569-1.233,1.258-1.227l16.961.15c.689.006,1.242.565,1.236,1.249l-.005.556Z",
    fill: "#58595b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M213.863,187.383l-19.456-.172-.006.73l19.455.172.007-.73Z",
    fill: "#231f20"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M202.491,167.865l-3.392-.03c-.125-.001-.225-.103-.224-.226l.004-.449c.001-.124.103-.224.228-.222l3.392.03c.125.001.225.102.224.226l-.004.449c-.001.123-.103.223-.228.222Z",
    fill: "#be1e2d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M202.504,166.436l-3.392-.03c-.125-.001-.225-.102-.224-.226l.004-.449c.001-.124.103-.223.228-.222l3.392.03c.125.001.225.102.224.226l-.004.449c-.001.124-.103.223-.228.222Z",
    fill: "#be1e2d"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M209.439,163.287l-10.232-.091c-.516-.004-.93-.422-.925-.933l.047-5.328c.004-.511.426-.922.941-.917l10.233.09c.515.005.929.423.924.934l-.047,5.327c-.004.512-.425.922-.941.918Z",
    fill: "#be1e2d"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M198.847,163.095c.123.062.262.1.41.102l10.232.09c.516.005.937-.406.941-.917l.048-5.327c0-.033-.007-.063-.01-.095l-11.621,6.147Z",
    fill: "#f97a7a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M199.21,162.86c-.328-.003-.592-.269-.589-.594l.047-5.328c.003-.324.272-.586.599-.583l10.233.09c.327.003.591.27.588.594l-.047,5.328c-.003.325-.271.586-.599.583l-10.232-.09Z",
    fill: "#e6e7e8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M199.614,159.406l9.401.083.019-2.067-9.401-.083-.019,2.067Z",
    fill: "#bcbec0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M199.592,161.973l9.401.083.018-2.067-9.401-.083-.018,2.067Z",
    fill: "#bcbec0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M199.627,157.951l-.975.81-.006.661.975-.811.006-.66Zm2.677-1.569l-.78-.007-1.169.971.78.007l1.169-.971Z",
    fill: "#eeeff0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M201.136,157.352l-.782-.007-.727.604-.006.661l1.515-1.258Z",
    fill: "#d2d3d5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M198.621,162.266v.054l.002-.002c-.002-.017-.002-.035-.002-.052Z",
    fill: "#d36872"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M201.991,159.428l-2.122-.019-1.232,1.024-.016,1.833c0,.017,0,.035.002.053l.973-.836.014-1.576l1.805.016.576-.495Zm3.516-3.018l-2.007-.018-1.169.971l2.044.019l1.132-.972Z",
    fill: "#eeeff0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M204.375,157.381l-2.044-.018-2.462,2.045l2.122.019l2.384-2.046Z",
    fill: "#d2d3d5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M201.415,159.922l-1.805-.016-.014,1.576l1.819-1.56Z",
    fill: "#d2d3d5"
  })))), /*#__PURE__*/React.createElement("g", null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 104,
    rx: 12,
    ry: 12,
    transform: "translate(35 133)",
    fill: "#f8f8f8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0072,212l-2.6683-9.455h1.8419l1.7035,6.948h.0877l1.8189-6.948h1.6758l1.8235,6.953h.0831l1.7035-6.953h1.842L82.2504,212h-1.6896l-1.8927-6.634h-.0739L76.6968,212h-1.6896Zm13.3947.138c-.6925,0-1.2926-.152-1.8004-.457-.5078-.304-.9018-.73-1.1818-1.278-.277-.548-.4155-1.188-.4155-1.921c0-.732.1385-1.374.4155-1.925.28-.551.674-.979,1.1818-1.283.5078-.305,1.1079-.457,1.8004-.457s1.2926.152,1.8004.457c.5078.304.9002.732,1.1772,1.283.2801.551.4201,1.193.4201,1.925c0,.733-.14,1.373-.4201,1.921-.277.548-.6694.974-1.1772,1.278-.5078.305-1.1079.457-1.8004.457Zm.0092-1.338c.3755,0,.6894-.103.9418-.31.2524-.209.4401-.489.5632-.84.1262-.351.1893-.742.1893-1.172c0-.434-.0631-.827-.1893-1.178-.1231-.354-.3108-.635-.5632-.844-.2524-.21-.5663-.314-.9418-.314-.3847,0-.7047.104-.9602.314-.2524.209-.4416.49-.5678.844-.1231.351-.1847.744-.1847,1.178c0,.43.0616.821.1847,1.172.1262.351.3154.631.5678.84.2555.207.5755.31.9602.31ZM93.218,212v-7.091h1.6204v1.182h.0739c.1292-.409.3508-.725.6648-.946.317-.225.6786-.337,1.0848-.337.0924,0,.1955.004.3093.013.117.007.2139.017.2909.033v1.537c-.0708-.025-.1831-.046-.337-.065-.1508-.021-.297-.032-.4386-.032-.3047,0-.5786.066-.8217.199-.2401.129-.4294.309-.5679.54-.1384.23-.2077.497-.2077.798v4.169h-1.6712Zm6.6778-2.225l-.0046-2.018h.2678l2.548-2.848h1.953l-3.135,3.49h-.346l-1.2832,1.376ZM98.3723,212v-9.455h1.6717v9.455h-1.6717Zm4.4507,0l-2.309-3.227l1.127-1.177L104.822,212h-1.999Z",
    transform: "translate(-.580451 0)",
    fill: "#141414"
  })), /*#__PURE__*/React.createElement("g", null, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M101.741,166.239c0-.433-.352-.784-.784-.784h-25.905c-.4328,0-.7842.351-.7842.784v17.009c0,.432.3514.784.7842.784h25.905c.432,0,.784-.352.784-.784v-17.009Z",
    fill: "#bf8b68"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1961,176.475c0-.154-.1251-.279-.2791-.279h-4.1623c-.1539,0-.2791.125-.2791.279v1.985c0,.154.1249.279.2791.279h4.1623c.154,0,.2791-.125.2791-.279v-1.985Z",
    clipRule: "evenodd",
    fill: "#e5ab4c",
    fillRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2676,172.991v.408c.104.093.2336.168.3741.225l10.8338,4.041v-.408l-10.8338-4.041c-.1405-.057-.2698-.132-.3741-.225Zm27.4734-.013c-.159.165-.37.307-.569.388l-10.976,3.952v.408l10.976-3.951c.199-.082.41-.224.569-.389v-.408Z",
    fill: "#a27659"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4756,177.257v.408l1.6139.602c.3226.08.5902.124.8504.124.2336,0,.4611-.036.7169-.112l1.5393-.554v-.408l-1.5393.555c-.2558.076-.4833.111-.7169.111-.2602,0-.5278-.044-.8506-.124l-1.6137-.602Z",
    fill: "#ecbb73"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M101.991,172.478c0,.346-.433.731-.819.888l-12.5145,4.506c-.5413.161-.9555.139-1.5673-.013l-12.4477-4.643c-.3453-.139-.6239-.392-.6239-.738v-6.926c0-.703.5703-1.273,1.2727-1.273h25.4267c.703,0,1.273.571,1.273,1.273v6.926",
    fill: "#d69d72"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M74,163.354h28v2.515h-28v-2.515Z",
    clipRule: "evenodd",
    fill: "#fac693",
    fillRule: "evenodd"
  })))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3817,175.747c0-.172-.1397-.311-.3121-.311h-4.4282c-.1721,0-.3118.139-.3118.311v2.218c0,.172.1397.311.3118.311h4.4282c.1721,0,.3121-.139.3121-.311v-2.218Z",
    clipRule: "evenodd",
    fill: "#ffca65",
    fillRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9698,164.624h-1.3817c-.0607,0-.1098.035-.1098.077v.167c0,.042.0491.077.1098.077h1.3817c.0607,0,.1098-.034.1098-.077v-.167c0-.042-.0491-.077-.1098-.077Zm7.0432-.035h-1.3818c-.0606,0-.1097.034-.1097.077v.167c0,.042.0488.076.1097.076h1.3818c.0604,0,.1098-.034.1098-.076v-.167c0-.043-.0494-.077-.1098-.077Z",
    fill: "#f9a254"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8674,164.645c-.0014.028-.0025.12-.0025.121h-1.0866c0,0-.0022-1.405-.0025-1.495-.0066-.566-.5918-1.097-1.3186-1.103-1.1012-.003-2.2027,0-3.3042,0-.6956.002-1.3255.504-1.328,1.111v1.486h-1.0902c0,0,0-.079-.0016-.12v-1.478c.0032-.892.6719-1.75,1.6282-2.046.2487-.077.5116-.117.7751-.119c1.1092-.003,2.2184-.003,3.3275,0c.9827.009,1.9332.599,2.2667,1.447.0903.231.1356.475.1367.718v1.478Z",
    clipRule: "evenodd",
    fill: "#c4856a",
    fillRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "eY1HTg86k94125",
    transform: "matrix(0 0 0 0 204.999999 301)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 104,
    rx: 12,
    ry: 12,
    transform: "translate(152 249)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.756,278.671c-.009.419-.032.84-.059,1.258.026-.418.05-.839.059-1.258h.735c.137-1.986.263-3.969.227-5.92h-1.058-3.323l.198,1.802c.275-.06.458-.115.458-.115v.004c.113-.031.231-.054.355-.054.654,0,1.195.476,1.298,1.101.011.071.019.142.019.215c0,.727-.59,1.316-1.317,1.316-.123,0-.241-.023-.355-.054v.004c0,0-.073-.019-.199-.044l.191,1.744h2.771v.001Z",
    fill: "#5e6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.717,272.751c.035,1.951-.09,3.934-.227,5.92h2.401l.188-1.717c-.045.011-.07.017-.07.017v-.004c-.113.031-.231.054-.355.054-.726,0-1.316-.589-1.316-1.316c0-.073.007-.144.019-.215.102-.624.644-1.101,1.297-1.101.124,0,.241.022.355.054v-.004c0,0,.131.04.336.088l.195-1.775h-.297-2.526v-.001Z",
    fill: "#727a82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.464,270.658c-.26-.65-.673-1.167-1.172-1.61-2.037.275-3.599,1.826-3.599,3.703h.643h3.323c.817-.397,1.16-1.383.805-2.093Z",
    fill: "#8b9cb0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.292,269.048c.499.443.912.96,1.172,1.611.355.71.013,1.696-.805,2.092h1.058h2.525.297.643c0-1.249-.694-2.353-1.757-3.035-.7-.448-1.557-.716-2.488-.716-.22.001-.435.02-.645.048Z",
    fill: "#c3d7eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.008,274.442c-.113-.031-.231-.054-.355-.054-.653,0-1.195.476-1.297,1.102.359,1.36,3.41.964,4.198.503.898-.525.734-.605,1.188.191.454.795,1.417,1.02,2.216.479.173-.278.275-.606.275-.958c0-1.009-.818-1.827-1.828-1.827-.303,0-.586.082-.839.213v-.01c0,0-1.158.607-1.954.607-.477,0-.958-.09-1.267-.162-.206-.048-.336-.088-.336-.088v.004h-.001Z",
    fill: "#ccdceb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.742,276.183c-.454-.796-.29-.717-1.188-.191-.788.461-3.839.857-4.198-.504-.012.07-.019.142-.019.215c0,.727.589,1.316,1.316,1.316.124,0,.241-.023.355-.054v.004c0,0,.025-.006.07-.017.208-.047.854-.179,1.533-.179.827,0,1.973.561,1.973.561v-.008c.247.126.524.202.82.202.657,0,1.232-.347,1.553-.868-.797.543-1.76.317-2.215-.477Z",
    fill: "#8099a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.257,276.183c.453-.796.29-.716,1.188-.191.788.461,3.839.857,4.199-.503-.103-.625-.645-1.102-1.298-1.102-.124,0-.241.022-.355.054v-.004c0,0-.183.057-.459.115-.305.066-.725.135-1.144.135-.796,0-1.955-.607-1.955-.607v.01c-.253-.132-.535-.213-.839-.213-1.01,0-1.827.818-1.827,1.827c0,.352.101.68.274.958.799.541,1.762.316,2.216-.479Z",
    fill: "#ccdceb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.991,276.966c.113.031.23.054.355.054.728,0,1.316-.589,1.316-1.316c0-.073-.007-.145-.018-.215-.36,1.361-3.411.965-4.199.504-.898-.526-.734-.605-1.188.191-.454.794-1.417,1.019-2.216.479.322.521.896.868,1.553.868.296,0,.573-.077.82-.202v.009c0,0,1.148-.562,1.973-.562.573,0,1.121.094,1.404.152.125.025.199.044.199.044v-.006h.001Z",
    fill: "#8099a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.196,303.488c.8-.336,1.39-1.184,1.39-1.959.148-1.267.053-2.535-.127-3.802-.022-.158-.046-.318-.071-.476-.05-.317-.103-.633-.158-.951-.056-.317-.112-.633-.168-.95-.061-.348-.12-.696-.175-1.043h-.4c-.801,1.024-2.806,3.855-2.806,6.561c0,1.197.671,2.236,1.657,2.764.076.006.15.007.223.003.074-.003.147-.012.218-.024.144-.025.283-.067.417-.123Zm-1.148-2.495c-.221-1.213.303-2.347.539-2.777.09-.166.297-.225.461-.136.166.09.227.297.136.461-.201.368-.648,1.33-.466,2.329.091.496.413.778.596.902.156.106.197.317.091.472-.066.098-.172.15-.282.15-.066,0-.132-.019-.191-.059-.47-.316-.783-.793-.884-1.342Z",
    fill: "#72dff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.062,295.349c.056.317.112.633.168.95.055.318.109.634.158.951.025.158.048.318.071.476.18,1.267.276,2.535.127,3.802c0,.776-.589,1.624-1.39,1.959-.133.056-.272.098-.416.123-.071.012-.144.021-.217.024-.074.003-.148.002-.223-.003.439.234.941.369,1.474.369.146,0,.287-.013.427-.032c1.528-.208,2.705-1.515,2.705-3.1c0-.842-.199-1.7-.494-2.513-.648-1.782-1.767-3.345-2.314-4.048h-.251c.056.347.114.694.175,1.042Z",
    fill: "#67c7d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.123,302.395c.109,0,.217-.052.282-.15.106-.156.064-.367-.091-.472-.183-.123-.505-.406-.595-.902-.183-.999.264-1.961.466-2.328.09-.166.029-.372-.137-.462-.164-.09-.371-.03-.461.136-.236.431-.76,1.564-.539,2.777.1.549.414,1.026.885,1.345.059.037.125.056.19.056Z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.49,278.671h-.735c-.009.419-.032.84-.059,1.259-.008.14-.018.279-.027.418-.107,1.675-.19,3.326.565,4.837.696,1.391,1.824,1.652,3.123,1.657.741.003,1.538-.077,2.34-.077c1.003-.001,2.014.123,2.936.691c1.421.946,1.961,2.553,1.93,4.283h2.344c.018-.812.01-2.37-.753-3.79-.802-1.495-2.028-2.743-5.012-4.266-2.878-1.471-3.244-2.258-3.244-3.459c0-.884,0-1.552,0-1.552h-1.009-2.399v-.001Z",
    fill: "#c3d7eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.565,291.738c.031-1.73-.51-3.336-1.93-4.283-.923-.568-1.933-.691-2.936-.691-.802,0-1.599.08-2.34.077-1.297-.005-2.427-.266-3.123-1.657-.756-1.511-.673-3.162-.565-4.836.008-.14.018-.28.027-.419.026-.419.05-.84.059-1.259h-2.771-1.202c0,0,0,.512,0,1.828c0,.307-.05.578-.133.82-.174.505-.505.879-.895,1.155-1.11,2.043-.495,4.704,1.144,6.343c1.463,1.646,3.516,1.524,5.566,1.414.898-.238,1.539-.506,2.418-.82.322-.115.677-.237,1.089-.366c1.933-.603,2.961.973,2.961,2.154c0,.2,0,.384,0,.551.04-.008.081-.012.123-.012h2.508v.001Z",
    fill: "#8b9cb0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.898,288.816c-1.639-1.638-2.254-4.299-1.144-6.342-.577.408-1.28.605-1.796.699v.777v4.418.579c.845.079,2.268.305,3.294.822c1.557.786,3.336.918,4.908.539.106-.026.205-.052.304-.078-2.05.11-4.102.233-5.566-1.414Z",
    fill: "#8392a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.314,288.368v1.688c0,.117-.024.228-.066.328h1.83c.486,0,.879-.394.879-.881v-.557-.579h-2.643v.001Z",
    fill: "#6f7b8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.314,283.95h2.644v-.777-.359c0-.486-.393-.879-.879-.879h-1.81c.03.085.046.177.046.272v1.743h-.001Z",
    fill: "#cedded"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.958,283.95h-2.644v4.418h2.644v-4.418Z",
    fill: "#9fb4c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.635,289.498c1.626-2.277,1.737-5.254,1.086-8.094-.08-.025-.164-.043-.252-.043h-.621c-.467,0-.846.379-.846.846v.943v6.02.326c.222.168.437.199.633.002Z",
    fill: "#d4e3f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.314,288.369v-4.418-1.743c0-.095-.015-.187-.046-.272-.087-.252-.292-.45-.549-.531.653,2.841.542,5.817-1.085,8.094-.196.196-.411.165-.634-.003v.561c0,.467.379.846.846.846h.621c.351,0,.651-.213.78-.517.043-.101.066-.212.066-.328v-1.689h.001Z",
    fill: "#becfe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.054,291.737c-.042,0-.083.005-.123.013-.27.056-.474.296-.474.583v1.376c0,.015.003.027.004.041c2.806.37,5.714.527,5.906-1.968-.07-.029-.148-.046-.228-.046h-.23-2.344-2.511v.001Z",
    fill: "#d4e3f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.462,293.751c.022.309.276.555.592.555h2.433.4.251h2.002c.329,0,.596-.267.596-.596v-1.376c0-.248-.152-.461-.368-.55-.192,2.494-3.1,2.337-5.906,1.967Z",
    fill: "#bdcde0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5 0 0 1.5 10.224319-53.524445)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k94150",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(140.479706 254.544778)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\ns \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k94152",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(135.759121 254.544778)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\ne \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k94154",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(133.488454 254.544778)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\ni \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k94156",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(130.156205 254.544778)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\nt \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k94158",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(127.931787 254.544778)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\ni \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k94160",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(125.804678 254.544778)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\nl \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k94162",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(123.508012 254.544778)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\ni \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k94164",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(120.238812 254.355117)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\nt \n")), /*#__PURE__*/React.createElement("text", {
    id: "eY1HTg86k94166",
    dx: 0,
    dy: 0,
    fontFamily: "\"eY1HTg86k941:::Inter\"",
    fontSize: 9,
    fontWeight: 500,
    transform: "translate(113.554168 254.544778)",
    opacity: 0,
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 500,
    strokeWidth: 0
  }, "\nU\n"))))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M279.763,545.166c0,21.972-17.957,39.851-40.027,39.851h-192.3544c-22.0704,0-40.02781-17.879-40.02781-39.851v-497.9932c0-21.973,17.95741-39.85114,40.02781-39.85114h194.3464c20.973,0,38.035,16.98704,38.035,37.86764v499.9767ZM241.728,0.000366h-194.3464C21.2534,0.000366,0,21.1599,0,47.1728v16.9412v3.5373v457.1047v3.541v16.869c0,26.012,21.2534,47.172,47.3816,47.172h192.3544c26.128,0,47.381-21.16,47.381-47.172v-16.882-3.538-457.1038-3.5419-18.911c0-24.9206-20.363-45.188934-45.389-45.188934Z",
    fill: "#002a3c"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "eY1HTg86k94169",
    width: 0.5,
    height: 9,
    rx: 0,
    ry: 0,
    transform: "translate(110.934564 260.930341)",
    opacity: 0,
    strokeWidth: 0
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "eY1HTg86k94170",
    width: 0.5,
    height: 9,
    rx: 0,
    ry: 0,
    transform: "translate(191.728867 260.604482)",
    opacity: 0,
    strokeWidth: 0
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "eY1HTg86k94171",
    width: 0.5,
    height: 9,
    rx: 0,
    ry: 0,
    transform: "translate(116.147904 261.188931)",
    opacity: 0,
    strokeWidth: 0
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@font-face {font-family: 'eY1HTg86k941:::Inter';font-style: normal;font-weight: 500;src: url(data:font/ttf;charset=utf-8;base64,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) format('truetype');}\n")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldersDemo);
export default __webpack_public_path__ + "static/media/FoldersDemo.bb63ad85bcc996854d5c858208f69805.svg";
export { ForwardRef as ReactComponent };